import { observable } from 'mobx'

class ContactStore {
  @observable companyCode = null
}

export default new ContactStore()
